module.exports = __webpack_public_path__ + "static/img/areaA_3.663978f.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/areaA_3.png
// module id = 1075
// module chunks = 1